<template>
  <div>
    <component :is="componentInstance" :matchDetails="matchDetails" :liveStatistics="liveStatistics" v-if="componentInstance !== null && matchDetails.betRadarId && liveStatistics.betRadarID" />
  </div>
</template>
<script>
  import store from '@/store';
  import { AVAILABLE_LIVE_TRACKERS } from '../../../models/trackers';

  export default {
    name: 'BsportsTracker',
    props: {
      matchDetails: {
        type: Object,
        required: true,
      },
      liveStatistics: {
        type: Object,
        required: true,
      }
    },
    computed: {
      componentInstance() {
        const sportClass = store.getters.getSportIconClass(this.matchDetails.sportId);
        const liveTracker = AVAILABLE_LIVE_TRACKERS.find(lt => lt.id === sportClass);

        if (!liveTracker) {
          return null;
        }
        return () => import(`./trackers/${liveTracker.name}`);
      },
    },
  };
</script>
